var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_4321",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_4321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5357 5.28571H21.7143V4.46429C21.7143 3.10893 20.6054 2 19.25 2H4.46429C3.10893 2 2 3.10893 2 4.46429V19.25C2 20.6054 3.10893 21.7143 4.46429 21.7143H5.28571V22.5357C5.28571 23.8911 6.39464 25 7.75 25H22.5357C23.8911 25 25 23.8911 25 22.5357V7.75C25 6.39464 23.8911 5.28571 22.5357 5.28571ZM4.46429 20.0714C4.0125 20.0714 3.64286 19.7018 3.64286 19.25V4.46429C3.64286 4.0125 4.0125 3.64286 4.46429 3.64286H19.25C19.7018 3.64286 20.0714 4.0125 20.0714 4.46429V5.28571H14.3214V11.4464L11.8571 9.80357L9.39286 11.4464V5.28571H7.75C6.39464 5.28571 5.28571 6.39464 5.28571 7.75V20.0714H4.46429Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibrary);
export default __webpack_public_path__ + "static/media/iconLibrary.1e648630f631e63b254bc5fa4bf922e8.svg";
export { ForwardRef as ReactComponent };